import { resourceReducer, getResources } from 'redux-resource';
import { httpStatusCodes } from 'redux-resource-plugins';

const insuranceContracts = resourceReducer('insuranceContracts', {
  plugins: [httpStatusCodes],
});

export default insuranceContracts;

export const getContracts = (state) => getResources(state);
export const getContract = (state, id) => state.resources[id];
export const getSubContracts = (state, subId, carrier) =>
  getResources(
    state,
    ({
      subscription,
      att_subscription,
      tracfone_subscription,
      quick_subscription,
    }) => {
      try {
        if (carrier === 'att' && att_subscription) {
          return subId === att_subscription.toString();
        } else if (carrier === 'quick' && quick_subscription) {
          return subId === quick_subscription.toString();
        } else if (carrier === 'tracfone' && tracfone_subscription) {
          return subId === tracfone_subscription.toString();
        } else if (carrier === 'sprint' && subscription) {
          return subId === subscription.toString();
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
  );
export const getCreatedContractStatus = (state) =>
  state.requests.create && state.requests.create.status;
export const getCreatedContract = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
export const getAllInsuranceContracts = (
  state,
  page,
  att_subscription,
  user_profile,
) => {
  if (att_subscription) {
    let subscriptionListKey = `page${page}_att_subscription${att_subscription}`;
    if (user_profile) {
      subscriptionListKey += `_user_profile_${user_profile}`;
    }
    return getResources(state, subscriptionListKey);
  }

  return getResources(state, `page${page}`);
};
